<template>
    <div>
        <div class="w-100 inner-line-hr-tag mt-3"></div>
        <div class="d-flex justify-content-between align-items-center mt-4 ">
            
            <div class="d-flex justify-content-between align-items-center">
                <!-- <span class="text-secondary fw-600 mr-4">{{ticket_number}}</span> -->
                <!-- <img src="/images/images-new/menu/info-24px.svg" alt="" style="height:20px;"> -->
                <!-- <span class="text-secondary fw-600 ml-4">{{subject}}</span> -->
                
                <span class="text-black fw-600 ml-1 fs-16">Comment Section</span>
            </div>
            <div>
                <!-- <span class="text-secondary fw-600 mr-4">{{formatDateTime(new Date())}}</span> -->
                <!-- <button class="btn btn-secondary btn-smm ml-2 text-white fs-14">
                    <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/prefix__edit.svg" alt="" style="height:15px;margin-bottom:3px;margin-right:4px">
                    Edit
                </button>
                <button class="btn btn-warning btn-smm ml-2 text-white fs-14">
                    <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/share.svg" alt="" style="height:15px;margin-bottom:3px;margin-right:4px">
                    Share
                </button> -->
            </div>
        </div>
        <div class=" mt-4">
            <!-- <div v-if="ajaxCallComments" class="conversions pl-4 pr-3 py-2 mt-3 text-center d-flex justify-content-center align-items-center">
                <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448f" class="text-center w-100 d-flex justify-content-center"/>
            </div> -->
            <div v-if="ajaxCallComments" class="d-flex align-items-center justify-content-center">
                <!-- <div class="LoaderPlacement">
                        <div class="digi-table-loader">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                </div> -->
                <img class="mt-5 mb-5" src="/static/images/new-theme2024/20 card.gif" width="100" alt="digi-loader">
            </div>
            <div class="conversions pl-4 pr-3 py-2 mt-3 text-center" v-else-if="!allComments.length && is_archived && !ajaxCallComments">
                <span class="ml-1 fw-600 text-black text-capitalize">There are no comments found...</span>
            </div>
            <div v-else class=" pl-1 py-2 mt-3" v-for="(comments,index) in allComments" :key="index">
                <div class="d-flex justify-content-between align-items-center">
                    <span>
                        <img :src="comments.profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" alt="" style="height:25px;margin-bottom:3px;margin-right:2px;width:25px;border-radius:50px;">
                        <span class="ml-1 fw-600 text-black">{{comments.created_by}}</span>
                    </span>
                    <span v-if="comments.showReply" class="text-dark fw-500 fs-12">
                        {{comments.created_date}}
                        <i v-if="is_archived !== true" class="icon icon-trash text-danger fs-18 ml-2 pointer" @click="deleteComment(comments)"></i>
                    </span>
                </div>
                <div>
                    <div class="ml-7">
                    <p class="mt-1 ml-1 overflow-comments">{{comments.comment}}</p>
                        <div class="mt-2">
                            <div class="" v-for="(attachment,index) in comments.attachments" :key="index">
                                <div class="d-flex attachment-image mt-2 mr-3 flex-column" :class="{'attachment-image-upload':attachment.progress<100 && attachment.error == ''}">
                                    <div class="img__wrap">
                                        <div style="border-radius:4px">
                                            <img v-if="attachment.name.endsWith('.pdf')" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images/pdf-icon.svg" style="width:167px;height:100px">
                                            <img v-else-if="attachment.name.endsWith('.pptx')" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images/ppt.svg" style="width:167px;height:100px">
                                            <img v-else-if="attachment.name.endsWith('.png')" :src="attachment.url" style="width:167px;height:100px">
                                            <img v-else-if="attachment.name.endsWith('.jpg')" :src="attachment.url" style="width:167px;height:100px">
                                            <img v-else-if="attachment.name.endsWith('.svg')" :src="attachment.url" style="width:167px;height:100px">
                                            <img v-else-if="attachment.name.endsWith('.xls') || attachment.name.endsWith('.xlsx')" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images/xls-icon.svg" style="width:167px;height:100px">
                                            <img v-else-if="attachment.name.endsWith('.doc') || attachment.name.endsWith('.docx')" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images/txt.svg" style="width:167px;height:100px">
                                            <img v-else-if="attachment.name.endsWith('.txt')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/txt%20icon.svg">
                                            <img v-else :src="attachment.url" alt="" style="width:167px;height:75px">
                                            <div class="img_inside_view">
                                                <span class="mr-3 pointer img_more" @click="previewImage(attachment)">
                                                    <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/eye.svg" alt="" style="width:15px">
                                                </span>
                                                <span class="ml-3 pointer img_more">
                                                    <a :href="attachment.url" download="">
                                                        <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/download_img.svg" alt="" style="width:10px">
                                                    </a>
                                                </span>
                                            </div>

                                        </div>
                                        <!-- <div class="img__description_layer" v-if="moreDesc">
                                            <div class="img__description">
                                                <span class="pointer" style="float:right" @click="viewMoreCancel()"><i class="icon icon-close text-white fs-14"></i></span>
                                                <span class="caption_d fs-12">{{attachment.cation}}
                                                </span>
                                            </div>
                                            <button class="view_btn pointer" @click="viewMoreDesc(attachment.cation)">
                                                View More
                                            </button>
                                        </div> -->
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <el-tooltip :content="attachment.name" placement="bottom">
                                            <!-- text-truncate -->
                                            <div class=" text-center d-block mx-width-220 pt-2">
                                                {{attachment.name}}
                                            </div>
                                        </el-tooltip>
                                    </div>
                                    <div class="img-caption px-2 pointer" @click="viewMoreDesc(attachment.cation)" v-if="!moreDesc">{{attachment.cation}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between align-items-center" v-for="(reply,rindex) in comments.replied_comments" :key="rindex">
                            <div class="w-100 mt-2">
                                <div class="d-flex justify-content-between">
                                    <span>
                                        <img :src="reply.profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" alt="" style="height:25px;margin-bottom:3px;margin-right:2px;width:25px;border-radius:50px;">
                                        <span class="ml-1 fw-600 text-black">{{reply.created_by}}</span>
                                    </span>
                                    <span class="text-dark fw-500 fs-12 pl-10">
                                        {{reply.created_date}}
                                        <i v-if="is_archived !== true" class="icon icon-trash text-danger fs-18 ml-2 pointer" @click="deleteComment(reply)"></i>
                                    </span>
                                </div>
                                <p class="mt-1 ml-1 pl-7 overflow-comments" :title="reply.comment">{{reply.comment}}</p>
                                <div class="mt-2">
                                    <div class="" v-for="(attachment,aindex) in reply.attachments" :key="aindex">
                                        <div class="d-flex attachment-image mt-2 mr-3 flex-column" :class="{'attachment-image-upload':attachment.progress<100 && attachment.error == ''}">
                                            <img v-if="attachment.name.endsWith('.pdf')" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images/pdf-icon.svg" style="width:167px;height:100px">
                                            <img v-else-if="attachment.name.endsWith('.pptx')" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images/ppt.svg" style="width:167px;height:100px">
                                            <img v-else-if="attachment.name.endsWith('.png')" :src="attachment.url" style="width:167px;height:100px">
                                            <img v-else-if="attachment.name.endsWith('.jpg')" :src="attachment.url" style="width:167px;height:100px">
                                            <img v-else-if="attachment.name.endsWith('.svg')" :src="attachment.url" style="width:167px;height:100px">
                                            <img v-else-if="attachment.name.endsWith('.xls') || attachment.name.endsWith('.xlsx')" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images/xls-icon.svg" style="width:167px;height:100px">
                                            <img v-else-if="attachment.name.endsWith('.doc') || attachment.name.endsWith('.docx')" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images/txt.svg" style="width:167px;height:100px">
                                            <img v-else-if="attachment.name.endsWith('.txt')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/txt%20icon.svg">
                                            <img v-else :src="attachment.url" alt="" style="width:167px;height:75px">
                                            <div class="img_inside_view">
                                                <span class="mr-3 pointer img_more" @click="previewImage(attachment)">
                                                    <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/eye.svg" alt="" style="width:15px">
                                                </span>
                                                <span class="ml-3 pointer img_more">
                                                    <a :href="attachment.url" download="">
                                                        <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/download_img.svg" alt="" style="width:10px">
                                                    </a>
                                                </span>
                                            </div>
                                            <div class="d-flex justify-content-between">
                                                <el-tooltip :content="attachment.name" placement="bottom">
                                                    <!-- text-truncate -->
                                                    <div class=" text-center d-block mx-width-220 pt-1">
                                                        {{attachment.name}}
                                                    </div>
                                                </el-tooltip>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <span class="fs-14 mt-1 pointer pl-7 ml-1 text-danger" v-if="reply.is_retry"  @click="retryReplyCommentApiCall(reply, index, rindex)">Retry</span>
                            </div>
                        </div>
                        <span class="fs-14 mt-1 pointer ml-1 text-danger" v-if="comments.is_retry && is_archived !== true"  @click="retryAddCommentApiCall(comments, index)">Retry</span>
                        <div class="fs-14 mt-1 text-secondary pointer ml-1" v-if="comments.showReply && is_archived !== true"  @click="toReply(comments._id)">Reply to</div>
                    </div>
                    <div class="py-2 mt-3" v-if="comments.showChild">
                        <div class="row">
                            <div class="col-lg-12 px-0">
                                <div class="pt-0 d-flex align-items-center" v-if="is_archived !== true">
                                    <!-- <span class="w-100 ml-8" v-if="disable_reply">
                                        <input name="comments" data-vv-as="Comment Name" v-model="comments['child_comments']" v-on:keypress="onAtInsideSignClick($event)" class="inputComments w-100" type="text" placeholder="Add Commentdd" />
                                        <i class="icon icon-send fs-16 text-white text-center disable-states" v-if="!isUploadingInProgress" @click="sendInsidePost(comments._id,comments.child_comments, index, rindex)" style="position:absolute;right:20px;top:5px;background-color:#005dae;border-radius:50px"></i>
                                    </span> -->
                                    <div class="w-100 ml-13 d-flex mr-6" v-if="!disable_reply">
                                        <div class="w-20">
                                            <span class="text-secondary fw-600 text-overflow mr-3">reply to</span>
                                            <span><img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png" alt="" style="height:25px;margin-right:2px"></span>
                                        </div>
                                        <div class="w-100">
                                            <!-- <input name="comments" data-vv-as="Comment Name" v-model="comments['child_comments']" v-on:keypress="onAtInsideSignClick($event)" class="inputComments w-100" type="text" placeholder="Add Comment" /> -->
                                            <input name="comments" data-vv-as="Comment Name" v-model="comments.child_comments" @input="$forceUpdate()"
                                                v-on:keypress="onAtInsideSignClick($event)" class="inputComments w-100"
                                                type="text" placeholder="Add Comment" maxlength="1000">
                                            <span class="pull-right text-right text-black font-600 fs-12">{{ 1000 - comments.child_comments.length}}/{{1000}}</span>


                                            <button v-if="!isUploadingInProgress" @click="sendInsidePost(comments._id,comments.child_comments, index, rindex)" class="btn btn-secondary btn-smm mr-2 mt-2" style="height:35px !important;border-radius: 5px !important;">
                                                <span class="text-white ml-1 hidden-sm-down fs-13">Add Comment</span>
                                            </button>
                                        </div> 
                                    </div>
                                    <div class="tagDrops" v-show="showInsideList">
                                        <span v-for="(user,uindex) in user_list" :key="uindex"  @click="selectTagUser(user,uindex)" >
                                            <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png" alt="" style="height:25px;margin-right:2px">
                                            {{user.name}}
                                        </span>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="py-2 mt-3 ">
                <div class="row">
                    <div class="col-lg-12 px-0">
                        <div class="pt-0 d-flex align-items-start" v-if="is_archived !== true">
                           <span>
                            <img class=" ml-4" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png" alt="" style="height:25px;margin-bottom:3px;margin-right:2px;width:25px;border-radius:50px;">
                               <!-- <i class="icon icon-pencil-circle text-new-blue ml-6"></i> -->
                           </span>
                           <span class="w-100 ml-2 mr-4">
                            
                            <template>
                                <div class="demo">
                                  <Mentionable :keys="['@', '#']":items="user_list" offset="6" insert-space @open="getUserList()" @close = "tagremove()">
                                  <template #no-result>
                                    {{ loading ? 'Loading...' : 'No result' }}
                                  </template>
                                  <template #item-@="{ item }">
                                      <div class="user">
                                        {{ item.label }}
                                      </div>
                                    </template>
                                    
                                  <!-- <textarea v-validate="'required'" name="comments" data-vv-as="Comment Name" rows="5" v-model="comment" v-on:keypress="onAtSignClick($event)" class="inputComments  w-100" type="text" placeholder="Add Comment" /> -->
                                  <textarea v-validate="'required'" name="comments" data-vv-as="Comment Name"
                                            rows="5" v-model="comment" v-on:keypress="onAtSignClick($event)"
                                            class="inputComments w-100" type="text" placeholder="Add Comment"
                                            maxlength="1000">
                                    </textarea>
                                    <span class="pull-right text-right text-black font-600 fs-12">{{ 1000 -  comment.length}}/{{1000}}</span>


                                    <!-- <template #no-result>
                                      <div class="dim">
                                        No result
                                      </div>
                                    </template>-->
                                  </Mentionable>
                                </div>
                              </template>
                                <!-- <div class="tagDrops" v-show="testDrop">
                                    <span v-for="(user,uindex) in user_list" :key="uindex"  @click="selectTagUser(user, uindex)" >
                                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png" alt="" style="height:25px;margin-right:2px">
                                        {{user.name}}
                                    </span>
                                </div>
                                <textarea v-validate="'required'" name="comments" data-vv-as="Comment Name" rows="5" v-model="comment" v-on:keypress="onAtSignClick($event)" class="inputComments w-100" type="text" placeholder="Add Comment" /> -->
                                <span class="inputBorder"></span>
                                <!-- <span class="invalid-feedback-form text-danger mt-0 text-left d-block" v-show="errors.has('comments')" style="display: inline !important">{{ errors.first("comments") }}</span> -->
                                <!-- <span v-if="!isUploadingInProgress && disable_reply" class="disable-states">
                                    <i class="icon icon-send fs-16 text-white text-center disable-states" @click="sendPost()" style="position:absolute;right:20px;top:5px;background-color:#f2f3f5;border-radius:50px;cursor: no-drop !important;"></i>
                                </span> -->
                                    <button v-if="!isUploadingInProgress && !disable_reply" class="btn btn-secondary btn-smm mr-2 mt-2" style="height:35px !important;border-radius: 5px !important;" @click="sendPost()">
                                        <span class="text-white ml-1 hidden-sm-down fs-13">Add Comment</span>
                                    </button>
                               </span>
                        </div>
                        <div class="attachment-bg-new ml-7 mr-4 mt-7 px-sm-5 px-2 pt-3" :class="is_archived !== true ? 'attachment-email' : ''">
                            <span class="fw-600 text-black fs-16 pt-4" v-if="is_archived !== true">
                                Upload Files
                            </span>
                            <div class="d-flex justify-content-center mt-4"  style="background:#f1f1f1;border-radius:4px;" v-if="is_archived !== true">
                                <div id="drop_zone_outside" @drop="dropHandlerOutside($event)" @dragover="dragOverHandlerOutside($event)" class="img-upload px-3 px-sm-15 pt-3 pb-3 text-center" style="background:#f1f1f1;border-radius:4px;">
                                    <img width="30" src="/static/images/draganddrop.svg" class="" alt="Capture Image"/>
                                    <span class="px-4 hide-on-mob text-black">Drag and Drop Files Here</span>
                                    <span class="pr-4 hide-on-mob text-black fw-600">or</span>
                                    <file-upload id="multiple"
                                            class="choose-file btn btn-new-primary"
                                            accept=".pdf,.doc,.xls,image/*"
                                            multiple @input-file="uploadAttachment($event)" ref="upload"
                                            webkitdirectory mozdirectory
                                            style="text-transform: none !important; padding:2px 18px 6px 18px !important;">
                                            <i class="icon ri-upload-2-line text-white fs-15 pr-1"></i>
                                            Click to Upload
                                        </file-upload>
                                    <label class="choose-file mt-1">
                                        <!-- <input type="file" id="upload_comment_file_upload_input_id" name="upload_comment_file_upload_name" multiple @change="uploadAttachment" accept=".pdf,.doc,.xls,image/*"> -->
                                    </label>
                                </div>
                            </div>
                            <!-- <div class="example-full" v-if="is_archived !== true">
                                <div class="btn-group" style="display: none;">
                                    <file-upload
                                        class="btn btn-primary dropdown-toggle"
                                        :multiple="multiple"
                                        :directory="directory"
                                        :size="size || 0"
                                        :thread="thread < 1 ? 1 : (thread > 5 ? 5 : thread)"
                                        :headers="headers"
                                        :data="data"
                                        :drop="drop"
                                        :drop-directory="dropDirectory"
                                        :add-index="addIndex"
                                        v-model="temp_attachments"
                                        @input-file="inputFile"
                                        ref="upload"
                                        name="upload_comment_file_upload_name"
                                        input-id="upload_comment_file_upload_input_id"
                                        webkitdirectory mozdirectory>
                                        <i class="icon icon-plus"></i>
                                            Select
                                    </file-upload>
                                </div>
                            </div> -->
                            <div class="d-flex flex-wrap align-items-center mt-4">
                                <div class="col-lg-6 col-md-6 col-sm-12" v-for="(attachment,index) in attachments" :key="index">
                                    <div class="mt-6" v-if="viewHereHide">
                                        <div class="d-flex align-items-center p-3">
                                            <div class="d-flex align-items-center" style="width:90%">
                                                <div>
                                                    <img src="/static/images/storage.svg" width="20"  @click="previewImage(attachment)">
                                                    <!-- <img v-if="attachment.name.endsWith('.pdf')" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images/pdf-icon.svg" style="width:167px;height:100px">
                                                    <img v-else-if="attachment.name.endsWith('.pptx')" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images/ppt.svg" style="width:167px;height:100px">
                                                    <div v-else-if="attachment.name.endsWith('.png')">
                                                        <img v-if="attachment.url" :src="attachment.url" style="width:167px;height:100px">
                                                        <img v-else src="https://cdn.digicollect.com/cdn/scmnew/images/scm/png-attachment.svg" style="width:167px;height:100px">
                                                    </div>
                                                    <div v-else-if="attachment.name.endsWith('.jpg')">
                                                        <img v-if="attachment.url" :src="attachment.url" style="width:167px;height:100px">
                                                        <img v-else src="https://cdn.digicollect.com/cdn/scmnew/images/scm/jpg.svg" style="width:167px;height:100px">
                                                    </div>
                                                    <div v-else-if="attachment.name.endsWith('.svg')">
                                                        <img v-if="attachment.url" :src="attachment.url" style="width:167px;height:100px">
                                                        <img src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg" style="width:167px;height:100px">
                                                    </div>
                                                    <div v-else-if="attachment.name.endsWith('.xls')">
                                                        <img v-if="attachment.url" :src="attachment.url" style="width:167px;height:100px">
                                                        <img v-else src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images/xls-icon.svg" style="width:167px;height:100px">
                                                    </div>
                                                    <div v-else-if="attachment.name.endsWith('.doc')">
                                                        <img v-if="attachment.url" :src="attachment.url" style="width:167px;height:100px">
                                                        <img v-else src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images/txt.svg" style="width:167px;height:100px">
                                                    </div>
                                                    <img v-else-if="attachment.name.endsWith('.jpg')" :src="attachment.url" style="width:167px;height:100px">
                                                    <img v-else-if="attachment.name.endsWith('.svg')" :src="attachment.url" style="width:167px;height:100px">
                                                    <img v-else-if="attachment.name.endsWith('.xls') || attachment.name.endsWith('.xlsx')" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images/xls-icon.svg" style="width:167px;height:100px">
                                                    <img v-else-if="attachment.name.endsWith('.doc') || attachment.name.endsWith('.docx') || attachment.name.endsWith('.txt')" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images/txt.svg" style="width:167px;height:100px">
                                                    <img v-else :src="attachment.url" alt="" style="width:167px;height:75px"> -->
                                                </div>
                                                <div class="col">
                                                    <div class="d-flex justify-content-between">
                                                        <el-tooltip :content="attachment.name" placement="top">
                                                            <!-- text-truncate -->
                                                            <div class="font-weight-bold d-block mx-width-220 text-truncate">
                                                                {{attachment.name}}
                                                            </div>
                                                        </el-tooltip>
                                                    </div>
                                                    <div v-if="attachment.uploading || attachment.url == undefined">
                                                        <progress-bar class="progressBar w-100" :class="{'error-upload':attachment.url == undefined}" :val="attachment.progress" size="small"></progress-bar>
                                                    </div>
                                                    <div class="d-flex justify-content-between">
                                                        <div class="text-danger pl-0 fw-500" v-if="attachment.error != ''">{{attachment.error}}...</div>
                                                        <div class="text-secondary fw-500" v-if="attachment.progress<100 && attachment.error == ''">{{attachment.progress}}% Uploading</div>
                                                        <div class="fw-500" v-if="attachment.progress<100 && attachment.error == ''">({{attachment.size | prettyBytes}})</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <span v-if="attachment.url && attachment.uploading == false" class="pointer"@click="deleteAttachment(attachment,index)">
                                                <!-- <img src="/static/images/new-theme2024/eye-line.svg" width="20" class="ml-7 pointer"> -->
                                                <img src="/static/images/delete-bin-4-line.svg" width="20" alt=""  class="pointer ml-2">
                                            </span>
                                            <!-- <div class="pointer ml-3" style="width:10%" @click="deleteAttachment(attachment,index)">
                                                <i class="icon icon-close fs-16 closeAttachment" v-if="attachment.uploading || attachment.url == undefined"></i>
                                                <i class="icon icon-trash text-danger fs-20" v-if="is_archived !== true && attachment.url && attachment.uploading == false"></i>
                                            </div> -->
                                            <div class="pointer ml-3" style="width:10%; z-index: 1;" @click="deleteAttachment(attachment,index)">
                                                <i class="icon icon-close fs-16 closeAttachment" v-if="attachment.uploading || attachment.url == undefined"></i>
                                                <!-- <i class="icon icon-trash text-secondary fs-20" v-if="attachment.url"></i> -->
                                            </div>
                                        </div>
                                        <!-- <div class="d-flex mt-3 pl-3 text-bg">
                                            <textarea name="" id="" cols="30" class="file-desc" v-model="attachment.cation" placeholder="Add a caption here…."></textarea>?
                                            <span class="pt-3 pl-2 pr-2 pointer">
                                                <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/save_desc.svg" alt="" style="width:20px">
                                            </span>
                                            <span class="pt-3 pl-2 pr-2 pointer">
                                                <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/edit_desc.svg" alt="" style="width:20px">
                                            </span>
                                        </div> -->
                                    </div>
                                    <div style="border-radius:4px;width:167px" v-if="viewHere">
                                        <img :src="attachment.url" alt="" style="width:167px;height:100px">
                                        <span class="pointer close-img" @click="closeHereImg()">
                                            <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/close_black.svg" alt="">
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
         <comment-files-description modal_name="files-description" :caption="captions"></comment-files-description>
    </div>
</template>
<script>
import FileUpload from 'vue-upload-component';
import attachments from "../mixins/attachments.js";
import ticket from '../mixins/ticket.js';
import convert from '../mixins/convert.js';
import { SweetModal } from 'sweet-modal-vue';
import Swal from 'sweetalert2';
import CommentFilesDescription from "./CommentFilesDescription";
import { EventBus } from '../eventBus/nav-bar-event.js';
import { Mentionable } from 'vue-mention'
import axios from 'axios';
export default {
    props:["showDetails",'subject','ticket_number', 'is_archived'],
    mixins: [attachments,ticket,convert],
    components:{
        FileUpload,
        SweetModal,
        Swal,
        Mentionable,
        CommentFilesDescription
    },
    data(){
        return{
            ajaxCallComments: false,
            success_msg:'',
            disable_reply: false,
            warning_msg:'',
            attachments:[],
            attachments_inside:[],
            temp_attachments:[],
            temp_attachment_inside:[],
            drop_inside: true,
            drop_directory_inside: true,
            accept: '*',
            extensions: '*',
            size: 1024 * 1024 * 10,
            multiple: true,
            directory: true,
            drop: true,
            dropDirectory: true,
            addIndex: false,
            thread: 3,
            name: 'file',
            postAction: '/upload/post',
            putAction: '/upload/put',
            headers: {
                'X-Csrf-Token': 'xxxx',
            },
            data: {
                '_csrf_token': 'xxxxxx',
            },
            autoCompress: 1024 * 1024,
            uploadAuto: false,
            isOption: false,
            comment:[],
            testDrop:false,
            showInsideList:false,
            allComments:[],
            comment_show:[],
            user_list:[],
            created_by:'',
            // tagged_users:{},
            replied_comments:[],
            search_key:'',
            // assigned_user_details:[],
            moreDesc:false,
            viewHere:false,
            viewHereHide:true,
            viewExpand:false,
            viewExpandHide:true,
            captions:'',
            view_caps: '',
            is_reply:false,
            dialogImageUrl: '',
            dialogVisible: false,
            text: '',
            loading: false,
            items: [
                {
                    value: 'akryum',
                    firstName: 'Guillaume',
                },
                {
                    value: 'posva',
                    firstName: 'Eduardo',
                },
                {
                    value: 'atinux',
                    firstName: 'Sébastien',
                },
            ],
            // users: [
            //     {
            //         value: 'akryum',
            //         firstName: 'Guillaume',
            //     },
            //     {
            //         value: 'posva',
            //         firstName: 'Eduardo',
            //     },
            //     {
            //         value: 'atinux',
            //         firstName: 'Sébastien',
            //     },
            // ]
            total_file_size: 0,
        }
    },
    methods:{
        getResumable(file, attachment) {
            this.isUploadingInProgress = true;
            attachment.uploading = true;
            let data = {
                file: attachment.name
            }
            data = new FormData()
            data.append('file', file)
            this.$http.post('https://cloudapis.digicollect.com/external/upload_file', data, {
                onUploadProgress: function (progressEvent) {
                    let progress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent
                        .total));
                    if (progress < 100) {
                        attachment.progress = progress;
                    }
                }.bind(this)
            })
            .then(response => {
                let resumable_url = response.data.url;
                attachment.url = resumable_url;
                attachment.progress = 100;
                attachment.uploading = false;
                this.isUploadingInProgress = false;
                delete attachment['source'];
                setTimeout(() => {
                    // this.saveFiles();
                }, 500);
            })
            .catch(error => {
            })
        },
        uploadAttachment(newFile, oldFile) {
            let contains_duplicates = false
            this.attachments.forEach((e) => {
                if(e.name == newFile.name){
                    contains_duplicates = true
                }
            })
            console.log("hi")
            console.log(newFile)
            if(this.attachments.length < 10 && !contains_duplicates){
                var input = newFile;
                this.total_file_size = this.total_file_size + input.file.size
                if (input.file) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: input.file.name,
                        size: JSON.stringify(input.file.size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: ""
                    }
                    this.attachments.push(attachment);
                    this.getResumable(input.file, this.attachments[this.attachments.length - 1]);
                }
            } else if(contains_duplicates){
                this.$toasted.global.error("This file is already uploaded")
            } else {
                this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
            }
        },
        tagremove(){
            this.comment = this.comment.replace('@','')
        },
        previewImage(file) {
            EventBus.$emit('ZindexChangeStart')
            this.$emit('previewImage', file)
        },
        viewHereImg(){
            this.viewHere = true
            this.viewHereHide = false
        },
        closeHereImg(){
            this.viewHere = false
            this.viewHereHide = true
        },
        viewExpands(){
            this.viewExpand = true
            this.viewExpandHide = false
        },
        closeExpand(){
            this.viewExpand = false
            this.viewExpandHide = true
        },
        hideReply(){
        },
        viewMoreDesc(cation){
            this.captions = cation
            setTimeout(() => {
                this.$modal.show('files-description')
            }, 1000);
        },
        viewMore(cation){
            this.view_caps = cation
            this.moreDesc = true
        },
        viewMoreCancel(){
            this.moreDesc = false
        },
        toReply(id){
            this.allComments.forEach((el,index)=>{
                this.disable_reply = false;
                if(el._id == id){
                    if(el.showReply){
                        el.showChild = true
                        el.showReply = false
                        el.child_comments = ''
                    }else{
                        el.showChild = false
                        el.showReply = true
                        el.child_comments = ''
                    }
                }

            })
            this.attachments = []
            this.attachments_inside = []
            this.is_reply =
            setTimeout(() => {
                document.getElementById('upload_inside_reply_file_upload_input_id').value = "";
                document.getElementById('upload_comment_file_upload_input_id').value = "";
            }, 500);
        },
        async retryReplyCommentApiCall(reply, index, rindex) {
            let params = {
                comment:this.allComments[index].replied_comments[rindex].comment,
                replied_to:this.allComments[index].replied_comments[rindex].replied_to,
                ticket_id:this.showDetails.ticket_id,
                attachments:this.allComments[index].replied_comments[rindex].attachments
            }
            params.attachments.forEach(attachment => {
                delete attachment['id'];
                delete attachment['progress']
                delete attachment['uploading']
                delete attachment['error']
                delete attachment['size']
                delete attachment['created_time']
            })
            this.sendInsidePostCall(params, index)
        },
        sendInsidePost(id,comment, index){
            this.disable_reply = false
            if(comment != ''){
                this.allComments[index].replied_comments.unshift({
                    comment: comment,
                    created_by: this.loggedInUser.full_name,
                    profile_pic: this.loggedInUser.profile_pic,
                    replied_to: id,
                    is_retry: false,
                    is_delete: false,
                    attachments: this.attachments_inside
                })
                let params = {
                    comment:comment,
                    replied_to:id,
                    ticket_id:this.showDetails.ticket_id,
                    attachments:this.attachments_inside
                }
                params.attachments.forEach(attachment => {
                    delete attachment['id'];
                    delete attachment['progress']
                    delete attachment['uploading']
                    delete attachment['error']
                    delete attachment['size']
                    delete attachment['created_time']
                })
                this.sendInsidePostCall(params, index)
                this.disable_reply = true;
            }else{
                this.$toasted.global.error("Please Fill All The Required Fields")
                this.disable_reply = false;
            }
            setTimeout(() => {
                this.disable_reply = false;
            }, 8000);
            this.$forceUpdate();
        },
        async sendInsidePostCall(params, index){
            this.disable_reply = false;
            try {
                let res = await this.addComments(params)
                this.allComments[index].replied_comments[this.allComments[index].replied_comments.length-1].is_delete = true
                // this.success_msg = res.response
                // this.$refs.success_modal.open();
                // setTimeout(() => {
                //     this.$refs.success_modal.close();
                    this.getComments()
                    this.toReply(params.replied_to)
                // }, 3000);
            } catch (reason) {
                this.allComments[index].replied_comments[this.allComments[index].replied_comments.length-1].is_retry = true
                this.toReply(params.replied_to)
                this.warning_msg = reason
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
                this.$forceUpdate()
            }
        },
        onAtSignClick: function(evt, event) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if((charCode === 64 || charCode.shiftKey === 50)){
                this.testDrop= true
            }else{
                this.testDrop= false
            }
        },
        onAtInsideSignClick: function(evt, event) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if((charCode === 64 || charCode.shiftKey === 50)){
                this.showInsideList= true
            }else{
                this.showInsideList= false
            }
        },
        deleteComment(comments){
            Swal.fire({
                title: 'Alert',
                text: "Are you sure want to delete this comment" + ' ' + JSON.stringify(comments.comment) + "?",
                type: 'warning',
                icon: 'warning',
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText:'YES',
                cancelButtonText:'NO'
            }).then((result) => {
                if (result.value) {
                    let params = {
                        comment_id:comments._id
                    }
                    this.confirmDelete(params)
                }
            })
        },
        async confirmDelete(params){
            try {
                let res = await this.deleteCommentOnly(params)
                this.success_msg = res.response
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.getComments();
                }, 3000);
            } catch (reason) {
                this.warning_msg = reason
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        insert(str, index, value) {
            return str.substr(0, index) + value + str.substr(index);
        },
        selectTagUser(user,index) {
            // if(this.allComments && this.allComments.length && this.allComments[index].child_comments){
            //     let value = this.insert(this.allComments[index].child_comments,this.allComments[index].child_comments.length,user.name)
            //     this.allComments[index].child_comments = value.replace('@','')
            // }
                let value = this.insert(this.comment,this.comment.length,user.name)
                this.comment = value.replace('@','')
            // }
            this.testDrop= false
            this.showInsideList = false
        },
        async retryAddCommentApiCall(comments, index) {
            try {
                let payload_data = {
                    attachments:this.allComments[index]['attachments'],
                    ticket_id:this.showDetails.ticket_id,
                    comment:this.allComments[index]['comment'],
                    replied_to:this.replied_to,
                }
                payload_data.attachments.forEach(attachment => {
                    delete attachment['id'];
                    delete attachment['progress']
                    delete attachment['uploading']
                    delete attachment['error']
                    delete attachment['size']
                    delete attachment['created_time']
                })
                let res = await this.addComments(payload_data)
                // this.success_msg = res.response
                // this.$refs.success_modal.open();
                // setTimeout(() => {
                //     this.$refs.success_modal.close();
                    EventBus.$emit('RecallNotification')
                    this.getComments()
                    this.comment = ''
                    this.attachments = []

                // }, 3000);
                this.disable_reply = false
            } catch (reason) {
                if(this.allComments.length) {
                    this.allComments[this.allComments.length-1]['is_retry'] = true;
                }
                this.warning_msg = reason
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        async sendPost(){
            this.$validator.validateAll().then(result => {
                this.disable_reply = false;
                if (result == true){
                    this.create_json.attachments.forEach(attachment => {
                        delete attachment['id'];
                        delete attachment['progress']
                        delete attachment['uploading']
                        delete attachment['error']
                        delete attachment['size']
                        delete attachment['created_time']
                    })
                    this.allComments.unshift({
                        comment: this.comment,
                        created_by: this.loggedInUser.full_name,
                        profile_pic: this.loggedInUser.profile_pic,
                        is_retry: false,
                        showChild: false,
                        showReply: false,
                        child_comments: '',
                        attachments: this.create_json.attachments
                    })
                    this.confirmSend()
                    this.disable_reply = true
                }else{
                    this.$toasted.global.error("Please Enter Some Comments")
                    this.disable_reply = false
                }
            })
        },
        async confirmSend(){
            try {
                let res = await this.addComments(this.create_json)
                // this.success_msg = res.response
                // this.$refs.success_modal.open();
                // setTimeout(() => {
                //     this.$refs.success_modal.close();
                    EventBus.$emit('RecallNotification')
                    this.getComments()
                    this.comment = ''
                    this.attachments = []

                // }, 3000);
                this.disable_reply = false
            } catch (reason) {
                if(this.allComments.length) {
                    this.allComments[this.allComments.length-1]['is_retry'] = true;
                }
                this.comment = ''
                this.attachments = []
                this.disable_reply = false
                this.warning_msg = reason
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        async getComments(){
            // this.ajaxCallComments = true
            try {
                let params={
                    ticket_id : this.showDetails.ticket_id,
                }
                let res = await this.getAllComments(params)
                this.allComments= res.response.all_comments
                this.allComments.forEach((el,index)=>{
                    el['showChild'] = false,
                    el['showReply'] = true
                    el['child_comments'] = ''
                })
                this.ajaxCallComments = false
            } catch (reason) {
                this.ajaxCallComments = false
            }
        },
        async getUserList(search_key){
            this.loading = true
            try {
                let params={
                    skip:0,
                    limit:100,
                    search_key:search_key
                }
                let res = await this.getUserForTickets(params)
                this.user_list = res.response.assigned_user_details;
                
                this.user_list.forEach((el,index)=>{
                    el["value"]=el.name
                    el["label"]=el.name
                })
            } catch (reason) {
                console.log(reason)
            }
            this.loading = false
        },
        RemoveAllSelected(categories) {
         this.selectedIndex.splice(categories._id);},
        deleteAttachment(attachment,index){
            this.attachments.forEach((el,elindex)=>{
                if(el.url == attachment.url){
                    this.attachments.splice(elindex,1)
                }
            })
        },
        deleteAttachmentInside(attachment,index){
            this.attachments_inside.forEach((el,elindex)=>{
                if(el.url == attachment.url){
                    this.attachments_inside.splice(elindex,1)
                }
            })
        },
        // inputFile(newFile, oldFile) {
        //     this.temp_attachments = []
        //     if (newFile && oldFile) {
        //         if (newFile.active && !oldFile.active) {
        //         if (newFile.size >= 0 && this.minSize > 0 && newFile.size < this.minSize) {
        //             this.$refs.upload.update(newFile, { error: 'size' })
        //         }
        //         }
        //         if (newFile.progress !== oldFile.progress) {
        //         }
        //         if (newFile.error && !oldFile.error) {
        //         }
        //         if (newFile.success && !oldFile.success) {
        //         }
        //     }
        //     if (!newFile && oldFile) {
        //         if (oldFile.success && oldFile.response.id) {
        //         }
        //     }
        //     if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        //         if (this.uploadAuto && !this.$refs.upload.active) {
        //             this.$refs.upload.active = true
        //             this.$refs.upload_inside.active = false
        //         }
        //     }
        //     this.input_file = newFile.file
        //     this.uploadAttachment(event)
        // },
        dropHandlerInside(evt) {
            // Prevent default behavior (Prevent file from being opened)
            evt.preventDefault();
            // Use DataTransfer interface to access the file(s)
            [...evt.dataTransfer.files].forEach((file, i) => {
                this.uploadAttachmentInsideFromDrop(file)
            });
        },
        dragOverHandlerInside(evt) {
            // Prevent default behavior (Prevent file from being opened)
            evt.preventDefault();
        },
        dropHandlerOutside(evt) {
            // Prevent default behavior (Prevent file from being opened)
            evt.preventDefault();
            // Use DataTransfer interface to access the file(s)
            [...evt.dataTransfer.files].forEach((file, i) => {
                this.uploadAttachmentOutsideFromDrop(file)
            });
        },
        dragOverHandlerOutside(evt) {
            // Prevent default behavior (Prevent file from being opened)
            evt.preventDefault();
        },
        inputFileInside(newFile, oldFile) {
            this.temp_attachment_inside = []
            if (newFile && oldFile) {
                if (newFile.active && !oldFile.active) {
                if (newFile.size >= 0 && this.minSize > 0 && newFile.size < this.minSize) {
                    this.$refs.upload_inside.update(newFile, { error: 'size' })
                }
                }
                if (newFile.progress !== oldFile.progress) {
                }
                if (newFile.error && !oldFile.error) {
                }
                if (newFile.success && !oldFile.success) {
                }
            }
            if (!newFile && oldFile) {
                if (oldFile.success && oldFile.response.id) {
                }
            }
            if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
                if (this.uploadAuto && !this.$refs.upload_inside.active) {
                    this.$refs.upload_inside.active = true
                    this.$refs.upload.active = false
                }
            }

            this.input_file_inside = newFile.file

            this.uploadAttachmentInside(event)
        },
    },
    computed:{
        create_json(){
            return{
                attachments:this.attachments,
                ticket_id:this.showDetails.ticket_id,
                comment:this.comment.replace('@',''),
                replied_to:this.replied_to,
            }
        },
        loggedInUser() {
            return this.$store.state.store.loggedInUser
        },
    },
    async mounted(){
        EventBus.$on('ticketFromFirebaseNotify',(data)=>{
            if(data.active_tab == 'comments'){
                this.getComments();
            }
        })
        this.getComments()
        this.getUserList()
    }
}
</script>
<style scoped>
.overflow-comments{
    word-wrap: break-word;
    white-space: pre-wrap;
}
.comment_conversion{
    border-radius: 10px;
    border: 2px solid #005dae;
    padding: 10px 25px 10px 25px;
}
.conversions{
    background-color: #f2f3f5;
    border-radius: 10px;
    padding-top: 18px !important;
    padding-bottom: 18px !important;
}
.inputComments{
    padding: 6.4px 7.9px 6.5px 10px;
    border-radius: 4px;
    border: solid 0.5px #f1f1f1;
  background-color: #f1f1f1;
}
.attachment-email{
    /* border: 1px solid #005dae; */
    padding: 6.4px 7.9px 6.5px 27.5px;
    border-radius: 4px;
    border: solid 0.5px #dfe6e9;

}
.file_attach{
    border: 1px solid #005dae;
    padding: 6.4px 7.9px 6.5px 27.5px;
    border-radius: 4px;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.files_type{
    background-color: #bbd9fd;
    border-radius: 5px;
    margin: 19px 4.5px 0 0;
    padding: 3.5px 8.6px 3.9px 9px;
    width: 300px;
    text-align: center;
}
.file_browse{
    margin: 10px 6px 19px 3.5px;
    padding: 7px 22px 7px 22.5px;
    border-radius: 8px;
    border: dashed 0.5px rgba(0, 0, 0, 0.38);
    background-color: #ffffff;
    display: flex;
    align-items: center;
}
.btn-upload {
    background: #1c61c2;
    border-radius: 7px !important;
    margin-left: 20px;
}
.tagDrops{
    position: absolute;
    top: -140px;
    left: 60px;
    background-color:#ffffff;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: 130px;
    max-height: 130px;
    overflow-y: scroll;
    width: 220px;
    border: 1px solid #1c61c2;
    box-shadow: 1px 2px 11px darkgrey;
}
.tagDrops span{
    padding: 8px 10px;
    width: 100%;
    border-bottom: 1px solid #ddd9d9;
    cursor: pointer;
}

.image-attach{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding-left: 0px !important;
    padding-right: 0px !important;
}
.image-attach-list{
  width:23%;
  margin-right:11px;
  margin-top: 15px;
  padding:5px;
  border-radius: 3px;
  display: flex;
  align-items: center;
}
.file-bg{
  border-radius: 2px;
  background-color: #bbd9fd;
}
.text-bg{
    background-color: #f1f1f1;
}
.file-desc{
    background-color: transparent;
    width: 100%;
    color: #130e0e;
}
.file-desc::placeholder{
    color: #130e0e !important;
}
.img__description_layer {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #2f3032;
  color: #fff;
  /* visibility: hidden; */
  /* opacity: 0; */
  transition: opacity .2s, visibility .2s;
}
.img__wrap {
  position: relative;
  height:100px;
  width: 167px;
}
/* .img__wrap:hover .img__description_layer {
  visibility: visible;
  opacity: 1;
} */

.img__description {
  transition: .2s;
  padding: 5px;
  cursor: pointer;
  max-height:73px;
  overflow:hidden;
  text-overflow: ellipsis;
}
.caption_d{
  max-height: 55px;
  max-width: 167px;
  overflow: hidden;
}
.view_btn{
    background-color: #54565a;
    border: 1px solid #eeeeef;
    border-radius: 7px;
    color: #ffffff;
    margin-left: 5px;
    font-size: 12px !important;
    font-weight:500;
}
.img-caption{
    background-color: #7d99ba;
    max-width: 167px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.hover_layer{
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #2f3032;
  color: #fff;
  visibility: hidden;
  opacity: 0;
  transition: opacity .2s, visibility .2s;

}
.img__wrap:hover .hover_layer {
  visibility: visible;
  opacity: 1;
}
.img_more_view{
    display: flex;
    align-items: center;
    justify-content: center;
    /* height:100px; */
    position: relative;
    bottom: 73px
}
.img_inside_view{
    display: flex;
    align-items: center;
    position: relative;
    bottom: 50px;
    left: 50px;
}
.img_more{
    background-color: #919396;
    border-radius: 50px;
    padding: 5px;
    height: 25px;
    width: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.close-img{
    position: relative;
    right: 30px;
    bottom: 30px;
}
.disable-states{
    pointer-events: none !important;
    cursor: no-drop !important;
}
.enable-state{
    cursor: pointer !important;
}
</style>